export const setCities = (data) => ({
  type: "SET_CITIES",
  payload: data,
});
export const setUserCities = (data) => ({
  type: "SET_USER_CITIES",
  payload: data,
});
export const clearCities = () => ({
  type: "CLEAR_CITIES",
});
